<template>                                                       <!-- 推荐游戏组件 -->
  <div class="side-body">  
    <div class="side-select-body" v-if="gift == 1">
      <h3 class="side-h3">
        <span>筛选礼包<i class="side-i"></i></span>
        <div class="side-gift-box">
          <input type="text" v-on:input="searchByGameName" placeholder="搜索游戏" 
          v-model="gameName" class="side-gift-search">
          <span class="side-gift-button" @click="searchByGameName">搜索</span>
        </div>
      </h3>
      <div class="filter-body">
        <div class="filter-box">
          <div class="filter-item" v-for="(item,x) in selectList" :key="x">
            <em :class="'tag-'+item.gift_tag">{{item.gift_tag}}</em>
            <div class="bd">
              <span v-for="(game,j) in item.gift_game" :key="j" @click="searchByGameGid(game.game_gid);">{{game.game_name}}</span>
            </div>
          </div>
        </div>
        <div class="vertical-scroll">
          <div class="rail"></div>
        </div>
      </div>
    </div>
    <div class="side-rank" v-if="gift == 1">
      <h3 class="side-h3">
        <span>游戏排行榜<i class="side-line" style="width: 100px;"></i></span>
        <a href="/gameCenter" class="side-more" target="_blank">更多<i></i></a>
      </h3>
      <ul style="margin-top: 25px;">
        <li v-for="(item, index) in rankList" :key="index" class="side-rank-li">
          <em class="side-rank-em">{{++index}}</em>
          <div class="side-rank-div">
            <a :href="item.game_device == 1 ? '/webOfficial/'+item.game_tag : '/mobileOfficial/'+item.game_tag" target="_blank" class="side-rank-img">
              <img :src="baseImageAddress + 'type=small&game_tag=' + item.game_tag"/>
            </a>
            <h6><span target="_blank">{{ item.game_title }}</span></h6>
            <p><span>{{ item.game_type }}</span> |
                {{ item.game_count }}人玩过</p>
          </div>
          <a :href="item.game_device == 1 ? '/webOfficial/'+item.game_tag : '/mobileOfficial/'+item.game_tag" target="_blank" class="side-rank-start">官网</a>
        </li>
      </ul>
    </div>
    <div class="side-hot-body">
      <h3 class="side-h3">
        <span>热门游戏<i class="side-i"></i></span>
        <a href="/gameCenter" target="_blank" class="side-more">更多<i></i></a>
      </h3>
      <ul>
        <li v-for="(item,index) in hotList" :key="index" class="side-hot-li">
          <a v-bind:title="item.game_title" :href="item.game_device == 1 ? '/webOfficial/'+item.game_tag : '/mobileOfficial/'+item.game_tag" target="_blank">
            <img v-bind:alt="item.game_title" :src="baseImageAddress + 'type=small&game_tag=' + item.game_tag" class="side-hot-img">
            <span>{{ item.game_title }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="side-gift-body">
      <h3 class="side-h3">
        <span>热门礼包<i class="side-i"></i></span>
        <a href="/gift" target="_blank" class="side-more">更多<i></i></a>
      </h3>
      <ul>
        <li v-for="(item,index) in giftList" :key="index" class="side-gift-li"
        @mouseover="selectGiftItem(index)" :class="giftDirector == index ? 'side-gift-active' : ''"
        v-bind:title="item.gift_name">
          <a :href="item.game_device == 1 ? '/webOfficial/'+item.game_tag : '/mobileOfficial/'+item.game_tag"
           class="dn side-gift-img" target="_blank">
            <img :src="baseImageAddress + 'type=small&game_tag=' + item.game_tag" 
              v-bind:alt="item.gift_name">
          </a>
          <span>{{item.gift_name}}</span>
          <span class="side-gift-get">
            剩余:
            <Progress :percent="getPercent(item.gift_count,item.gift_max,0)" class="side-gift-bar">
              <span>{{getPercent(item.gift_count,item.gift_max,1)}}</span>
            </Progress>
          </span>
          <span class="dn side-gift-time">截止至:<em>{{new Date(item.gift_time+31536000000).Format("yyyy-MM-dd")}}</em></span>
          <a class="dn side-gift-a" v-bind:title="item.gift_name" target="_blank" @click="enterGiftDetails(item.game_gid,item.gift_id)">领取</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name:'RecommendSide',
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseQrAddress(){
        return this.$store.state.constant.baseQrAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      ApkTransfer(){
        return this.$store.state.constant.ApkTransfer;
      }
    },
    methods:{
      searchByGameName(){
        if(this.oldGameName != this.gameName){
          this.oldGameName = this.gameName;
          this.$emit('searchByGameName', this.gameName);
        }
      },
      searchByGameGid(value){
        this.$emit('searchByGameGid',value);
      },
      getRightSide(){
        this.$http.get('/query_right_side?type='+this.type).then(res=>{
          if (res.data.code ==2000) {
            this.hotList = res.data.data.game;
            this.giftList = res.data.data.gift;
          }         
        });
      },
      getRankSide(){
        this.$http.get('/query_rank_side').then(res=>{
          if(res.data.code == 2000){
            this.rankList = res.data.data;
          }
        });
      },
      getSelectSide(){
        this.$http.get('/select_gift_group').then(res=>{
          if(res.data.code == 2000){
            var group = ['A','B','C','D','E','F','G','H',
            'I','J','K','L','M','N','O','P','Q','R','S',
            'T','U','V','W','X','Y','Z'];
            for (var i of group) {
              var newArr = res.data.data.filter(function(item){
                return item.game_short == i;
              });
              if(newArr.length > 0){
                this.selectList.push({'gift_tag':i,'gift_game':newArr});
              }
            }
          }
        });
      },
      enterGiftDetails(gid,id){
        window.open(this.$router.resolve({name:"giftDetails",query:{lid:id,gid:gid}}).href,"_blank");
      },
      selectGiftItem(value){
        this.giftDirector = value;
      },
      getPercent(count,max,type) {
        if(count == undefined){
          count = 1;
        }
        if(max == undefined){
          max = 1;
        }
        let number = (max-count)/max*100;
        if(type == 0){
          return number; 
        }else{
          if(number > 100){
            number = 100;
          }
          if(number < 0){
            number = 0;
          }
          return (number).toFixed(2)+"%";
        } 
      },
    },
    data(){
      return{
        rankList:[],
        hotList:[],
        giftList:[],
        selectList:[],
        gameName:"",
        oldGameName:"",
        loginState:false,
        giftDirector:0,

      }
    },
    props: {
      type:{
        type:Number,
        default:0
      },
      gift:{
        type:Number,
        default:0
      }
    },
    mounted(){
      if(window.sessionStorage.getItem("token") != null){
        this.loginState = true;
      }else{
        this.loginState = false;
      }
      if(this.gift == 1){
        var fatherScrollHeight,fatherClientHeight; //父高度,滚动高度
        var warp = document.querySelector('.filter-box');
        fatherClientHeight = warp.clientHeight; //获取父高度
        fatherScrollHeight = warp.scrollHeight; //获取父可滚动高度
        var present = fatherClientHeight / fatherScrollHeight;
        var scrollWarp = document.querySelector('.rail');
        scrollWarp.style.height = present*80 + '%';
        warp.addEventListener('scroll',function(e){
          scrollWarp.style.transform = 'translateY('+e.target.scrollTop*100/fatherClientHeight+'%)';
        });
        this.getRankSide();
        this.getSelectSide();
      }
      this.getRightSide();
    }
  }
</script>
<style src="@/assets/css/recommend_side.css" scoped></style>
<style>
  .side-gift-bar .ivu-progress-inner{
    background: #ddd;
  }
  .side-gift-bar .ivu-progress-bg{
    background: linear-gradient(to right,#2ccab7,#3fdb9d);
  }
</style>